import s from "./formWarning.module.css";
import {checkoutAttentionIcon} from "../../assets";

const FormWarning = () => {
    return (
        <div className={`${s.attentionBadge}`}>
            <img
                src={checkoutAttentionIcon}
                alt="Attention icon"
            />
            <p>
                Parece que você esqueceu de preencher algo importante. Verifique e tente novamente.
            </p>
        </div>
    )
}

export default FormWarning;
